import React from 'react';
import { FaCopy, FaCheck, FaWhatsapp } from 'react-icons/fa';
import { ContactItem as StyledContactItem, ContactDescription, PhoneNumberWrapper, CopyButton, WhatsAppButton } from '../styles/supportStyles';

/**
 * Componente para exibir um item de contato (telefone ou WhatsApp)
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.item - Objeto contendo description, number e rawNumber
 * @param {string} props.type - Tipo do contato: 'whatsapp' ou outro (ex: 'phone')
 * @param {string|null} props.copiedNumber - Número que foi copiado atualmente (para feedback visual)
 * @param {Function} props.onCopyNumber - Callback para copiar o número
 * @param {Function} props.onGetWhatsAppLink - Callback para gerar link do WhatsApp
 */
export const ContactItemComponent = ({
  item,
  type,
  copiedNumber,
  onCopyNumber,
  onGetWhatsAppLink
}) => {
  const isWhatsApp = type === 'whatsapp';

  return (
    <StyledContactItem>
      <ContactDescription>{item.description}</ContactDescription>

      <PhoneNumberWrapper $hasButton={true}>
        <span>{item.number}</span>

        <CopyButton onClick={() => onCopyNumber(item.number, item.rawNumber)}>
          {copiedNumber === item.number ? <FaCheck /> : <FaCopy />}
          {copiedNumber === item.number ? 'Copiado!' : 'Copiar Número'}
        </CopyButton>
      </PhoneNumberWrapper>

      {isWhatsApp && (
        <WhatsAppButton
          href={onGetWhatsAppLink(item.rawNumber)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp /> Enviar Mensagem no WhatsApp
        </WhatsAppButton>
      )}
    </StyledContactItem>
  );
};